import { createContext, useContext, useState } from 'react';
import { Notification } from 'services';

export const NOTIFICATION = {
  id: 0,
  type: 0,
  status: 0,
  isRead: 0,
  contentId: 0,
  image: '',
  content: '',
  contentBold: null,
  readAt: '',
  createdAt: '',
  skype: '',
  courseId: 0,
};
const NotificationContext = createContext({
  notification: NOTIFICATION,
  changeNotification: (payload: Notification) => {},
});

// eslint-disable-next-line react/prop-types
function NotificationProvider({ children }: any) {
  const [notification, setNotification] = useState<any | Notification>(
    NOTIFICATION,
  );

  const changeNotification = (payload: Notification) => {
    setNotification(payload);
  };
  return (
    <NotificationContext.Provider value={{ notification, changeNotification }}>
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotificationContext = () => useContext(NotificationContext);

export { NotificationProvider };
